import Vue from 'vue'
import Router from 'vue-router'
import { publicRoute, protectedRoute } from './config'
import VueSimpleAlert from 'vue-simple-alert'

const routes = publicRoute.concat(protectedRoute)
const loginPath = '/auth/login'
const settingsPath = '/settings'

Vue.use(Router)
const router = new Router({
  linkActiveClass: 'active',
  routes: routes,
})
// router gards
// eslint-disable-next-line
router.beforeEach((to, from, next) => {
  if (to.path !== loginPath && !localStorage.getItem('isLoggedIn')) {
    next({ path: '/auth/login' })
  } else if (to.path === settingsPath) {
    VueSimpleAlert.prompt('Please enter password:', '', undefined, undefined, { input: 'password' })
      .then((text) => {
        if (text === 'TallBoy2018') next()
      })
      .catch(() => console.log('canceled'))
  } else {
    document.title = `TSB Living - ${to.name}`
    next()
  }
})

export default router
